module.exports = __webpack_public_path__ + "img/telegram-logo-dark.207b3fee.png";